import type { PageLoad } from './$types';
import * as m from '$lib/paraglide/messages';
import { SITE_URL } from '$lib/constants/links';
import { serializeSchema } from '$lib/jsonld';
import { buildSeoMeta } from '$lib/seo';
import { buildFaqSchema } from '$lib/jsonld';
import { faqAbout } from '$lib/data/faq';

export const prerender = true;

export const load: PageLoad = ({ url }) => {
	const pageUrl = `${SITE_URL}/about-me`;

	return {
		seo: buildSeoMeta({
			type: 'home',
			title: m.contact_me(),
			description: m.contact_page_description(),
			url: url.href
		}),
		jsonld: serializeSchema({
			'@context': 'https://schema.org',
			'@graph': [
				// Page web
				{
					'@type': 'AboutPage',
					'@id': `${pageUrl}#webpage`,
					url: pageUrl,
					name: 'À propos de Juslin Komenan — Product Engineer & Digital Architect',
					description:
						"Product Engineer avec 10+ ans d'expérience, je construis des solutions digitales à fort impact pour startups et PME, et forme la prochaine génération de créateurs via l'Academy.",
					breadcrumb: { '@id': `${pageUrl}#breadcrumb` },
					isPartOf: { '@id': `${SITE_URL}/#website` },
					about: { '@id': `${SITE_URL}/#person` }
				},

				// Fil d'Ariane
				{
					'@type': 'BreadcrumbList',
					'@id': `${pageUrl}#breadcrumb`,
					itemListElement: [
						{
							'@type': 'ListItem',
							position: 1,
							name: 'Accueil',
							item: SITE_URL
						},
						{
							'@type': 'ListItem',
							position: 2,
							name: 'À propos',
							item: pageUrl
						}
					]
				},

				// Personne
				{
					'@type': 'Person',
					'@id': `${SITE_URL}/#person`,
					name: 'Juslin Komenan',
					jobTitle: 'Product Engineer & Digital Architect',
					description:
						"Product Engineer avec plus de 10 ans d'expérience dans la tech — des startups aux grands groupes. Je construis des solutions digitales à fort impact et forme la prochaine génération de créateurs via l'Academy.",
					url: SITE_URL,
					sameAs: [
						'https://www.linkedin.com/in/juslin', // à adapter
						'https://github.com/juslin03' // à adapter
					],
					address: {
						'@type': 'PostalAddress',
						addressLocality: 'Abidjan',
						addressCountry: 'CI'
					},
					email: 'komenan.komenan0@gmail.com',
					telephone: '+225 07 59 84 28 78',
					knowsAbout: [
						'SvelteKit',
						'Node.js',
						'PostgreSQL',
						'Architecture logicielle',
						'Développement MVP',
						'SaaS',
						'Automatisation',
						'Intelligence Artificielle',
						'Stratégie digitale'
					],
					hasOccupation: {
						'@type': 'Occupation',
						name: 'Product Engineer',
						occupationLocation: {
							'@type': 'Country',
							name: "Côte d'Ivoire"
						},
						skills: 'SvelteKit, Node.js, PostgreSQL, TypeScript, Architecture logicielle, IA'
					}
				},

				buildFaqSchema(faqAbout)
			]
		}),
		faqItems: faqAbout
	};
};
